import React, { useImperativeHandle, useRef, useState } from "react";
import { RCCRefModalProps, RCCHookToast, RCCServicesApi, RCCAlert } from "react-common-components";
import { useTranslation } from "src/context/Translations/context";
import { standardErrorMessages } from "src/utils/errors";
import ModalSide from "../Modal/styles";
import { IEftba004, IRefModalSelectUsers, ISelectedEftba005, RefObjectCallback } from "./interface";
import UserGrouper from "./components/grouper";
import Loader from "../Loader";
import Modal from "../Modal";

const ModalSelectUsers: React.ForwardRefRenderFunction<IRefModalSelectUsers> = (_,ref) => {

	const { translate } = useTranslation();
	const {addToast} = RCCHookToast();

	const onCallbackFunction = useRef<RefObjectCallback>({
		callback: () => {}
	});
	const modalSelectUsersRef = useRef<RCCRefModalProps>(null);

	const [ loading, setLoading ] = useState(true);
	const [ error, setError ] = useState(true);
	const [ groupers, setGroupers ] = useState<IEftba004[]>([]);

	const [selectedUsersList, setSelectedUsersList] =  useState<Array<ISelectedEftba005>>();

	const requestGroupers = async() => {
		setError(false);
		setLoading(true);
		try {
			const {data} = await RCCServicesApi.getRequest({
				method: "UsersGroups/List"
			});
			setGroupers(data.listRecords);
			setLoading(false);
		} catch (err) {
			standardErrorMessages(err, translate("Erro ao carregar grupos de usuários"), addToast);
			setError(true);
			setLoading(false);
		}
	};

	const submitModal = () => {
		if(onCallbackFunction.current?.callback){
			if(selectedUsersList && selectedUsersList.length > 0){
				const onlyUnique = Array.from(new Set(selectedUsersList?.map((s) => s.efa005Id)))
					.map((id) => ({
						efa005Id: id,
						...selectedUsersList?.find((s) => s.efa005Id === id)
					}));
				onCallbackFunction.current.callback(onlyUnique as ISelectedEftba005[]);
			}else
				onCallbackFunction.current.callback(undefined);
		}
		modalSelectUsersRef.current?.closeModal();
	};

	const openModal = (callback: (listOfUsers: ISelectedEftba005[] | undefined) => void) => {
		setSelectedUsersList(undefined);
  	onCallbackFunction.current.callback = callback;			
		requestGroupers();
		modalSelectUsersRef.current?.openModal();
	};

	useImperativeHandle(ref, () => ({
  	openModal
	}));

	return (
  	<>
			<Modal
				ref={modalSelectUsersRef}
				header={{
					title: translate("Adicionar usuários por grupo"),
					icon: {
						name:  "users"
					}
				}}
				withoutForm
				onSubmit={submitModal}
				onClose={() => {
					if(onCallbackFunction.current?.callback)
						onCallbackFunction.current?.callback(undefined);
				}}
				footer= {{
					showSaveButton: true,
					saveButtonText: translate("Adicionar usuários"),
					cancelButtonText: translate("Cancelar")
				}}
				styleInline={ModalSide}
			>

				{loading && <Loader /> }

				{error && <RCCAlert
					color="red"
					title={translate("Erro")}
					description={translate("Erro ao carregar grupos de usuários")}
				/>}

				{!loading && !error && groupers && (
					<>
						{groupers?.map((grouper) => 
							<UserGrouper 
								key={`${grouper.efa004Id}-grouper-users`}
								disabled={false}
								grouper={grouper}
								setSelectedUsersList={setSelectedUsersList}
							/>
						)}
					</>
				)}
			</Modal>
  	</>
	);

};

export default React.forwardRef(ModalSelectUsers);

